import {NavClickHandleClick, ViewSearchResultsHandleSubmit} from 'helpers-ga4';

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.isHeaderHidden = false; // Track header visibility
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeader = document.querySelector('sticky-header');

    if (stickyHeader.classList.contains('global-header--nav-visible')) return;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const isScrollingDown = scrollTop > this.currentScrollTop;
    const isAboveHeader = scrollTop <= this.headerBounds.top;
    const isBelowHeader = scrollTop > this.headerBounds.bottom;

    if (isAboveHeader) {
      requestAnimationFrame(this.reset.bind(this));
      this.currentScrollTop = scrollTop;
      return;
    }

    if (isScrollingDown && isBelowHeader && !this.preventHide) {
      if (!this.isHeaderHidden) {
        requestAnimationFrame(this.hide.bind(this));
        this.isHeaderHidden = true;
      }
    } else if (
      !isScrollingDown &&
      isBelowHeader &&
      !this.preventReveal &&
      !document.querySelector('.jump-link-navigation__remove-header-sticky')
    ) {
      if (this.isHeaderHidden) {
        requestAnimationFrame(this.reveal.bind(this));
        this.isHeaderHidden = false;
      }
    } else if (
      !isScrollingDown &&
      isBelowHeader &&
      !document.querySelector('.jump-link-navigation__remove-header-sticky')
    ) {
      window.clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);

      if (!this.isHeaderHidden) {
        requestAnimationFrame(this.hide.bind(this));
        this.isHeaderHidden = true;
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
    );
    this.closeMenuDisclosure();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
}

let resizing = false;

// main nav: keyboard accessibility
const mainNavHandleEscKey = (e) => {
  if (e.key === 'Escape') {
    const visibleClass = 'global-header__mega-menu--visible';
    const parent = document.querySelector(`.${visibleClass}`);

    if (parent) {
      const button = document.querySelector(`.${visibleClass} > button`);
      button.setAttribute('aria-expanded', 'false');
      document.querySelector(`.${visibleClass}`).classList.remove(visibleClass);

      document.querySelector('body').classList.remove('overflow-hidden');
      button.focus();

      const mainContent = document.querySelector('main');
      const footerContent = document.querySelector('footer');
      if (mainContent) {
        mainContent.removeAttribute('inert');
      }
      if (footerContent) {
        footerContent.removeAttribute('inert');
      }
    }
    mobileNavCleanClasses();
  }
};

const mainNavHandleFocus = (e) => {
  const parent = e.target.closest('[data-index]');
  const parentIndex = parent.getAttribute('data-index');
  const visibleClass = 'global-header__mega-menu--visible';

  if (
    document.querySelector(
      `.global-header__mega-menu--visible:not([data-index="${parentIndex}"]).${visibleClass}`,
    )
  ) {
    const element = document.querySelector(
      `.global-header__mega-menu--visible:not([data-index="${parentIndex}"]).${visibleClass}`,
    );
    element.classList.remove(visibleClass);
    document.querySelector('body').classList.remove('overflow-hidden');

    const mainContent = document.querySelector('main');
    const footerContent = document.querySelector('footer');
    if (mainContent) {
      mainContent.removeAttribute('inert');
    }
    if (footerContent) {
      footerContent.removeAttribute('inert');
    }
  }
};

const mainNavCloseOnTabOut = (e) => {
  let mqList = document.querySelector('.disabled-old-navigation')
    ? window.matchMedia('(min-width: 1400px)')
    : window.matchMedia('(min-width: 1024px)');

  const menu = document.getElementById('menu');
  const disabledOriginalHeader = menu.getAttribute(
    'data-disabled-original-header',
  );
  if (disabledOriginalHeader === 'true') {
    mqList = window.matchMedia('(min-width: 1200px)');
  }

  const navItems = document.querySelectorAll('.global-header__nav-item button');

  if (mqList.matches) {
    navItems.forEach((item) => {
      item.addEventListener('focus', mainNavHandleFocus);
    });
  } else {
    navItems.forEach((item) => {
      item.removeEventListener('focus', mainNavHandleFocus);
    });
  }
};

// main nav: mobile functionality

const fixMenuHeight = () => {
  const menu = document.getElementById('menu');
  const announcement = document.querySelector(
    '#shopify-section-announcement-bar',
  );
  const navRow = document.querySelector('.global-header__nav-row');
  const navItems = document.querySelector('.global-header__nav-items');

  const announcementBounding = announcement?.getBoundingClientRect() || 0;
  const announcementHeight = announcement?.offsetHeight
    ? announcementBounding.top < 0
      ? announcementBounding.height + announcementBounding.top
      : announcementBounding.height
    : 0;
  const navRowHeight = navRow?.offsetHeight || 0;
  navItems.style.top = announcementHeight + navRowHeight - 2 + 'px';

  menu.style.setProperty(
    '--before-top',
    announcementHeight + navRowHeight - 2 + 'px',
  );

  const bodyHTML = document.querySelector('body');
  bodyHTML.style.setProperty(
    '--body-before-top',
    announcementHeight + navRowHeight - 2 + 'px',
  );
};

const mobileNavOpenHandleClick = () => {
  const menu = document.getElementById('menu');
  const stickyHeader = document.querySelector('sticky-header');
  const button = document.getElementById('globalHeaderMobileButton');

  stickyHeader.classList.toggle('global-header--nav-visible');
  document.querySelector('body').classList.toggle('overflow-hidden');

  const mainContent = document.querySelector('main');
  const footerContent = document.querySelector('footer');
  if (mainContent) {
    mainContent.toggleAttribute('inert');
  }
  if (footerContent) {
    footerContent.toggleAttribute('inert');
  }

  fixMenuHeight();

  menu.setAttribute(
    'aria-hidden',
    button.getAttribute('aria-expanded') === 'true' ? 'true' : 'false',
  );

  if (button.getAttribute('aria-expanded') === 'true') {
    menu.classList.add('visibility-hidden');
  } else {
    menu.classList.remove('visibility-hidden');
  }

  button.setAttribute(
    'aria-expanded',
    button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
  );
  button.innerHTML =
    button.getAttribute('aria-expanded') === 'true'
      ? 'Close Primary Navigation'
      : 'Open Primary Navigation';
};

const mobileNavShowChildrenHandleClick = (e) => {
  let checkForLi = false;
  if (!e.target.parentElement.classList.contains('global-header__nav-item')) {
    checkForLi = true;
  }
  const parentEl = checkForLi
    ? e.target.closest('li.global-header__nav-item')
    : e.target.parentElement;
  let closeTab = false;

  if (parentEl.classList.contains('global-header__mega-menu--show')) {
    closeTab = true;
  }

  const menuShow = document.querySelectorAll('.global-header__mega-menu--show');
  menuShow.forEach((menu) => {
    menu.classList.remove('global-header__mega-menu--show');

    const button = menu.querySelector('button');
    button.setAttribute('aria-expanded', 'false');
  });

  if (!closeTab) {
    parentEl.classList.toggle('global-header__mega-menu--show');
    const button = parentEl.querySelector('button');
    button.setAttribute(
      'aria-expanded',
      button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
    );
  }
};

const mobileNavCleanClasses = () => {
  const navItems = document.querySelectorAll('.global-header__nav-item');
  const stickyHeader = document.querySelector('sticky-header');

  stickyHeader.classList.remove('global-header--nav-visible');
  document.querySelector('body').classList.remove('overflow-hidden');

  const mainContent = document.querySelector('main');
  const footerContent = document.querySelector('footer');
  if (mainContent) {
    mainContent.removeAttribute('inert');
  }
  if (footerContent) {
    footerContent.removeAttribute('inert');
  }
  navItems.forEach((link) => {
    link.classList.remove('global-header__nav-item--hide');
    link.classList.remove('global-header__mega-menu--show');
    const button = link.querySelector('button');
    button?.setAttribute('aria-expanded', 'false');
  });
};

const mobileChildItemsHandleClick = (e) => {
  e.preventDefault();
  mobileNavCleanClasses();
  const target = e.target.target === '' ? '_self' : `${e.target.target}`;
  window.open(e.target.href, target);
};

const mobileNavHandleEscKey = (e) => {
  if (e.key === 'Escape') {
    const hamburgerButton = document.getElementById('globalHeaderMobileButton');
    if (hamburgerButton.getAttribute('aria-expanded') === 'true') {
      mobileNavOpenHandleClick();
      mobileNavCleanClasses();
      hamburgerButton.focus();
    }
  }
};

const mobileMenu = () => {
  let mqList = document.querySelector('.disabled-old-navigation')
    ? window.matchMedia('(max-width: 1399px)')
    : window.matchMedia('(max-width: 1023px)');

  const menu = document.getElementById('menu');
  const disabledOriginalHeader = menu.getAttribute(
    'data-disabled-original-header',
  );
  if (disabledOriginalHeader === 'true') {
    mqList = window.matchMedia('(max-width: 1199px)');
  }

  const stickyHeader = document.querySelector('sticky-header');
  const button = document.getElementById('globalHeaderMobileButton');
  const parentItems = document.querySelectorAll(
    '.global-header__nav-item--has-children',
  );
  const childItems = document.querySelectorAll('.global-header__mega-menu a');
  const navLogin = document.querySelector('.global-header__nav-item--login');
  const mobileLastButton = document.querySelector(
    '.global-header__nav-item--mobile-button',
  );
  const logo = document.querySelector('.section-nav-logo');
  const nav = document.querySelector('.section-nav-desktop');
  const navLinks = document.querySelector('.section-nav-icon-links');

  if (mqList.matches) {
    if (disabledOriginalHeader === 'true') {
      let sibling = navLinks.nextElementSibling;
      if (!sibling) {
        navLinks.after(nav);
        logo.focus();
      }
    }

    stickyHeader.classList.remove('global-header--nav-visible');
    menu.setAttribute('aria-hidden', 'true');
    menu.classList.add('visibility-hidden');

    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = 'Open Primary Navigation';

    //event listeners
    button.addEventListener('click', mobileNavOpenHandleClick);
    parentItems.forEach((parent) => {
      parent.addEventListener('click', mobileNavShowChildrenHandleClick, true);
    });
    childItems.forEach((child) => {
      child.addEventListener('click', mobileChildItemsHandleClick);
    });
    document.addEventListener('keyup', mobileNavHandleEscKey);
    if (mobileLastButton) {
      mobileLastButton?.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
        }
      });
    } else {
      navLogin?.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
        }
      });
    }
  } else {
    fixMenuHeight();

    const headerIcons = document.querySelectorAll('.header__icon');
    if (disabledOriginalHeader === 'true') {
      let sibling = logo.nextElementSibling;
      if (!sibling?.classList.contains('section-nav-desktop')) {
        logo.after(nav);
        logo.focus();
      }
    }
    menu.classList.remove('visibility-hidden');
    button.removeEventListener('click', mobileNavOpenHandleClick);
    parentItems.forEach((parent) => {
      parent.removeEventListener(
        'click',
        mobileNavShowChildrenHandleClick,
        true,
      );
    });
    childItems.forEach((child) => {
      child.removeEventListener('click', mobileChildItemsHandleClick);
    });
    document.removeEventListener('keyup', mobileNavHandleEscKey);
    mobileNavCleanClasses();
    if (mobileLastButton) {
      mobileLastButton?.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
        }
      });
    } else {
      navLogin?.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
        }
      });
    }

    headerIcons.forEach((icon) => {
      icon.addEventListener('focus', () => {
        const el = document.querySelector(`.global-header__mega-menu--visible`);
        if (!el) return;

        el.classList.remove('global-header__mega-menu--visible');

        const button = el.querySelector(`button`);
        button?.setAttribute('aria-expanded', 'false');

        document.querySelector('body').classList.remove('overflow-hidden');

        const mainContent = document.querySelector('main');
        const footerContent = document.querySelector('footer');
        if (mainContent) {
          mainContent.removeAttribute('inert');
        }
        if (footerContent) {
          footerContent.removeAttribute('inert');
        }
      });
    });
  }
};

// main nav: desktop hover functionality

const mainNavHandleMouseOver = (e) => {
  const el = e.target.hasAttribute('data-index')
    ? e.target
    : e.target.closest('[data-index]');
  el.classList.add('global-header__mega-menu--visible');

  const button = el.querySelector(`button`);
  button?.setAttribute('aria-expanded', 'true');

  document.querySelector('body').classList.add('overflow-hidden');

  const mainContent = document.querySelector('main');
  const footerContent = document.querySelector('footer');
  if (mainContent) {
    mainContent.setAttribute('inert', '');
  }
  if (footerContent) {
    footerContent.setAttribute('inert', '');
  }
};

const mainNavHandleMouseOut = (e) => {
  const el = e.target.hasAttribute('data-index')
    ? e.target
    : e.target.closest('[data-index]');
  el.classList.remove('global-header__mega-menu--visible');

  const button = el.querySelector(`button`);
  button?.setAttribute('aria-expanded', 'false');

  document.querySelector('body').classList.remove('overflow-hidden');

  const mainContent = document.querySelector('main');
  const footerContent = document.querySelector('footer');
  if (mainContent) {
    mainContent.removeAttribute('inert');
  }
  if (footerContent) {
    footerContent.removeAttribute('inert');
  }
};

const mainNavHandleClick = (e) => {
  // Note: If Triggered by mouse event we do not want changes but if triggered by keyboard or screen reader we do
  // Use only e.offsetX === 0 && e.offsetY === 0 for reliable screen reader detection (including NVDA on Windows)
  const isKeyboardActivated = e.offsetX === 0 && e.offsetY === 0;

  if (isKeyboardActivated) {
    console.log('keyboard/screen reader activated');
    const visibleClass = 'global-header__mega-menu--visible';
    const el = e.target.hasAttribute('data-index')
      ? e.target
      : e.target.closest('[data-index]');
    el.classList.toggle(visibleClass);
    const button = e.target.hasAttribute('aria-expanded')
      ? e.target
      : e.target.tagName == 'DIV'
        ? e.target.closest('button')
        : document.querySelector(`.${visibleClass} > button`);

    const mainContent = document.querySelector('main');
    const footerContent = document.querySelector('footer');
    if (el.classList.contains(visibleClass)) {
      button?.setAttribute('aria-expanded', 'true');
      document.querySelector('body').classList.add('overflow-hidden');
      if (mainContent) {
        mainContent.setAttribute('inert', '');
      }
      if (footerContent) {
        footerContent.setAttribute('inert', '');
      }
    } else {
      button?.setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('overflow-hidden');
      if (mainContent) {
        mainContent.removeAttribute('inert');
      }
      if (footerContent) {
        footerContent.removeAttribute('inert');
      }
    }
  } else {
    console.log('mouse activated');
  }
};

const mainNavItemHover = () => {
  let mqList = document.querySelector('.disabled-old-navigation')
    ? window.matchMedia('(min-width: 1400px)')
    : window.matchMedia('(min-width: 1024px)');

  const menu = document.getElementById('menu');
  const disabledOriginalHeader = menu.getAttribute(
    'data-disabled-original-header',
  );
  if (disabledOriginalHeader === 'true') {
    mqList = window.matchMedia('(min-width: 1200px)');
  }

  const parentLink = document.querySelectorAll(
    '.global-header__nav-item--has-children',
  );

  if (mqList.matches) {
    menu.addEventListener('keyup', mainNavHandleEscKey);
    menu.removeAttribute('aria-hidden');
    parentLink.forEach((link, i) => {
      link.addEventListener('mouseover', mainNavHandleMouseOver);
      link.addEventListener('mouseout', mainNavHandleMouseOut);
      link.addEventListener('click', mainNavHandleClick);
    });
  } else {
    parentLink.forEach((link, i) => {
      link.removeEventListener('mouseover', mainNavHandleMouseOver);
      link.removeEventListener('mouseout', mainNavHandleMouseOut);
      link.removeEventListener('click', mainNavHandleClick);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('sticky-header', StickyHeader);
  mobileMenu();
  mainNavItemHover();
  mainNavCloseOnTabOut();

  const searchForm = `siteSearch`;
  const navLinks = document.querySelectorAll('#menu ul li a');
  const currentPath = window.location.pathname;
  navLinks.forEach((link) => {
    link.removeAttribute('aria-current');
    if (link.getAttribute('href') === currentPath) {
      link.setAttribute('aria-current', 'page');
    }
  });

  document
    .getElementById(searchForm)
    .addEventListener('submit', ViewSearchResultsHandleSubmit);
});

window.addEventListener('resize', (e) => {
  if (!resizing) {
    resizing = true;
    setTimeout(() => {
      resizing = false;
      mobileMenu();
      mainNavItemHover();
      mainNavCloseOnTabOut();
    }, 1000);
  }
});
